export const formatHMS = (secs) => {
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  const s = secs % 60;
  return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
};

// Compact "01:05" style used by chart hover tooltips (daily bar chart) and
// the project donut chart, shorter than formatHMS since it never needs
// seconds. Rounds to the nearest minute (1:59:40 gives "02:00"); hours have
// at least two digits and can go past 99.
export const formatHours = (secs) => {
  const minutes = Math.round(secs / 60);
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};
